import {QueryLangFilterOperator} from '../../../enums/query-lang-filter-operator';
import {QueryLangFilterCriterionInput} from '../../../models/filters/query-lang-filter-criterion-input';

export class FilterAssetBySymbolInput extends QueryLangFilterCriterionInput {
    public override fieldNames = ['symbol'];
    public placeholder = 'components.filters.asset';
    public override name = 'filter-asset-by-name';
    public override operator = QueryLangFilterOperator.LIKE;

    public override apply(): void {
        return; // Not used.
    }
}
